const securityActionTypes =  {    
    RETRIEVED_SECURITY_IP_FILTERS: "RETRIEVED_SECURITY_IP_FILTERS",
    RETRIEVED_SECURITY_IP_FILTER: "RETRIEVED_SECURITY_IP_FILTER",
    RETRIEVED_SECURITY_BASIC_LOGIN_SETTINS: "RETRIEVED_SECURITY_BASIC_LOGIN_SETTINS",
    UPDATED_SECURITY_BASIC_LOGIN_SETTINS: "UPDATED_SECURITY_BASIC_LOGIN_SETTINS",
    UPDATED_SECURITY_IP_FILTER: "UPDATED_SECURITY_IP_FILTER",
    DELETED_SECURITY_IP_FILTER: "DELETED_SECURITY_IP_FILTER",
    RETRIEVED_SECURITY_MEMBER_SETTINS: "RETRIEVED_SECURITY_MEMBER_SETTINS",
    UPDATED_SECURITY_MEMBER_SETTINS: "UPDATED_SECURITY_MEMBER_SETTINS",
    RETRIEVED_SECURITY_REGISTRATION_SETTINS: "RETRIEVED_SECURITY_REGISTRATION_SETTINS",
    UPDATED_SECURITY_REGISTRATION_SETTINS: "UPDATED_SECURITY_REGISTRATION_SETTINS",
    RETRIEVED_SECURITY_SSL_SETTINS: "RETRIEVED_SECURITY_SSL_SETTINS",
    UPDATED_SECURITY_SSL_SETTINS: "UPDATED_SECURITY_SSL_SETTINS",
    RETRIEVED_SECURITY_OTHER_SETTINS: "RETRIEVED_SECURITY_OTHER_SETTINS",
    UPDATED_SECURITY_OTHER_SETTINS: "UPDATED_SECURITY_OTHER_SETTINS",
    RETRIEVED_SECURITY_BULLETINS: "RETRIEVED_SECURITY_BULLETINS",
    RETRIEVED_SECURITY_SUPERUSER_ACTIVITIES: "RETRIEVED_SECURITY_SUPERUSER_ACTIVITIES",
    RETRIEVED_SECURITY_AUDITCHECK_RESULTS: "RETRIEVED_SECURITY_AUDITCHECK_RESULTS",
    RETRIEVED_SECURITY_AUDITCHECK_RESULT: "RETRIEVED_SECURITY_AUDITCHECK_RESULT",
    RETRIEVED_SECURITY_SEARCH_FILE_SYSTEM_DATABASE: "RETRIEVED_SECURITY_SEARCH_FILE_SYSTEM_DATABASE",
    RETRIEVED_SECURITY_LAST_MODIFIED_SETTINGS: "RETRIEVED_SECURITY_LAST_MODIFIED_SETTINGS",
    RETRIEVED_SECURITY_LAST_MODIFIED_FILES: "RETRIEVED_SECURITY_LAST_MODIFIED_FILES",
    SECURITY_BASIC_LOGIN_SETTINS_CLIENT_MODIFIED: "SECURITY_BASIC_LOGIN_SETTINS_CLIENT_MODIFIED",
    SECURITY_MEMBER_SETTINS_CLIENT_MODIFIED: "SECURITY_MEMBER_SETTINS_CLIENT_MODIFIED",
    SECURITY_REGISTRATION_SETTINS_CLIENT_MODIFIED: "SECURITY_REGISTRATION_SETTINS_CLIENT_MODIFIED",
    SECURITY_SSL_SETTINS_CLIENT_MODIFIED: "SECURITY_SSL_SETTINS_CLIENT_MODIFIED",
    SECURITY_OTHER_SETTINS_CLIENT_MODIFIED:"SECURITY_OTHER_SETTINS_CLIENT_MODIFIED",
    UPDATED_SECURITY_SEARCH_FILE_SYSTEM_DATABASE_KEYWORD: "UPDATED_SECURITY_SEARCH_FILE_SYSTEM_DATABASE_KEYWORD",
    UPDATED_SECURITY_SEARCH_FILE_SYSTEM_DATABASE_ACTIVE_TAB: "UPDATED_SECURITY_SEARCH_FILE_SYSTEM_DATABASE_ACTIVE_TAB"
};
export default securityActionTypes;
